import http from 'apis/config/http-service';
import { useCallback } from 'react';
import { CreditFacilityDto } from './use-get-credit-facilities-api';

const endpoint = 'ums/v1/cms/bnpl/credit-facilities';

type TOption = {
  value: number;
  label: string;
  restaurantId?: number;
};

export function useSearchBnplFacilitiesApi() {
  const loadOptions = useCallback((inputValue: string, callback: (options: TOption[]) => void) => {
    if (inputValue.length < 2) {
      callback([]);
      return;
    }

    http
      .get(endpoint, {
        params: {
          search: inputValue,
          status: 'active',
          page: 1,
          limit: 20,
        },
      })
      .then((res) => {
        const options: TOption[] = (res?.data?.data || []).map((item: CreditFacilityDto) => ({
          value: item.id,
          label: `#${item.id} — ${item.restaurant?.nameEn} (${item.supplier?.name})`,
          restaurantId: item.restaurantId,
        }));
        callback(options);
      })
      .catch(() => callback([]));
  }, []);

  return { loadOptions };
}
